import {
  FormLabel,
  FormLabelForNonInteractiveElement,
} from "../form-label/form-label";
import { LabelMethod } from "./label-prop";

/**
 * @deprecated
 */
interface InputLabelProps {
  id: string;
  labelMethod: LabelMethod;
  /**
   * `true` the element to-be-labelled is `<input>` or `<button>`; otherwise (e.g. `<div>`), `false`.
   */
  isElementInteractive: boolean;
  name?: string;
  required?: boolean;
  tooltip?: string;
  UNSAFELabelStyling?: string;
}
/**
 * @deprecated
 *
 * Renders either an accessible default label, or a screenreader-only label.
 */
const InputLabel = (props: InputLabelProps) => {
  switch (props.labelMethod.type) {
    case "default":
      if (props.isElementInteractive)
        return (
          <FormLabel
            unsafeLabelStyling={props.UNSAFELabelStyling}
            label={props.labelMethod.label}
            name={props.name}
            required={props.required}
            tooltip={props.tooltip}
            htmlFor={props.id}
          />
        );
      else
        return (
          <FormLabelForNonInteractiveElement
            id={props.id}
            unsafeLabelStyling={props.UNSAFELabelStyling}
            label={props.labelMethod.label}
            name={props.name}
            required={props.required}
            tooltip={props.tooltip}
          />
        );
    case "hidden":
      if (!props.isElementInteractive) {
        return (
          <p className="sr-only" id={props.id}>
            {props.labelMethod.label}
          </p>
        );
      }
      return (
        <label className="sr-only" htmlFor={props.id}>
          {props.labelMethod.label}
        </label>
      );
    default:
      return null;
  }
};

export default InputLabel;
